var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser && _vm.currentUser.isDying && _vm.currentUser.lives > 0)?_c('div',{staticClass:"dying-message"},[_vm._v(" Play a beer to save yourself! ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }